import { createAsyncThunk } from '@/redux/createAsyncThunk';

export const saveExistingBidderEmail = createAsyncThunk<string, string>(
    'la/ui/bidderExists/saveExistingBidderEmail',
    (email) => email
);
